module.exports = __webpack_public_path__ + "img/oralTest_sub27.6d2e62b1.jpg";